import {Component, OnInit, AfterViewInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

import {LogService} from '../../services/log.service';
import {PerfService} from '../../services/perf.service';


@Component({
	selector: 'redirect',
	templateUrl: './redirect.component.html',
	styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit, AfterViewInit {
	constructor(
		private location: Location,
		private router: Router,

		private log: LogService,
		private perf: PerfService
	) {}


	ngOnInit() {
		let currentPath = this.location.path();
		this.log.warn('Redirecting from invalid path.  path=' + currentPath);
		this.router.navigate(['']);
	}


	ngAfterViewInit() {
		this.perf.markTabLoadEnd('redirect');
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/redirect/redirect.component.ts